import {
  CompletePartDataSet,
  ERoleHatItemId,
  ILobbyPlayerMatchPrep,
  IPlayerCreds,
  UUID
} from '@nova/types';

import { cloneCompletePartDataSet } from './lobby-clone-complete-part-data-set';

interface CreatePlayerParams {
  id: UUID;
  nickname: string;
  locale: string;
  level: number;
  team?: number;
  slot?: number;
  isReadyState?: boolean;
  parts: CompletePartDataSet;
  roleSkillDatasetKey: ERoleHatItemId;
  socketId?: string;
}

// TODO: Have playerCreds.novaUser.gameData.equippedParts come in as type CompletePartDataSet
/**
 * Creates a lobby player.
 *
 * @param playerCreds - The player credentials.
 * @param authHeaders - The authentication headers.
 * @returns A promise that resolves to an `ILobbyPlayer` object.
 */
export function createLobbyPlayer(playerCreds: IPlayerCreds): ILobbyPlayerMatchPrep {
  const { novaUser, socketId } = playerCreds;

  return createPlayerObject({
    id: novaUser.id,
    nickname: novaUser.minUserDetails.nickname.fullName,
    level: novaUser.minUserDetails.level,
    locale: novaUser.minUserDetails.studentInfo.localeId,
    parts: cloneCompletePartDataSet(novaUser.gameplayData.equippedParts),
    roleSkillDatasetKey: novaUser.gameplayData.activeCoreSkillId,
    socketId
  });
}

/**
 * Creates a player object with the specified properties
 * @param params Player creation parameters
 */
export function createPlayerObject(
  { id, nickname, locale, level, parts, roleSkillDatasetKey, socketId, team = 0, slot = 0, isReadyState = false }: CreatePlayerParams
): ILobbyPlayerMatchPrep {
  return {
    id: id.toUpperCase() as UUID,
    nickname,
    locale,
    level,
    team,
    slot,
    isReadyState,
    parts,
    roleSkillDatasetKey,
    socketId
  };
}
